import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import { FormHelperText } from '@mui/material';

export function ErrorMessage({ message }: { message: string | undefined }) {
	return message ? (
		<FormHelperText
			sx={{
				display: 'flex',
				alignItems: 'center',
				gap: '9px',
				marginBottom: '4px',
				color: '#FD3333',
			}}
		>
			<ErrorOutlineOutlinedIcon color="error" />
			{message}
		</FormHelperText>
	) : (
		<></>
	);
}
